import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ projects }) =>
    present(
      repository
        .getWbsMeta(projects)
        .then((meta) => ({ projects, meta }))
        .catch(() => Promise.reject({ projects })),
    );
}

export type { Interactor };

export { createInteractor };
